import { render, staticRenderFns } from "./inputOptionItem.vue?vue&type=template&id=0acd52cb"
import script from "./inputOptionItem.vue?vue&type=script&lang=js"
export * from "./inputOptionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports